import { useState } from 'react';
import { Modal, ModalBody, Button, Stack } from '@7shifts/sous-chef-base';
import type {
    RoleSelectionRequiredResponse,
    PunchResponse
} from '@src/api/punchTypes';
import { useTranslation } from '@src/i18n';

interface RoleSelectionModalProps {
    response: RoleSelectionRequiredResponse;
    onExecute: (execute: () => Promise<PunchResponse>) => void;
    onDismiss: () => void;
}

export function RoleSelectionModal({
    response,
    onExecute,
    onDismiss
}: RoleSelectionModalProps) {
    const [submitted, setSubmitted] = useState(false);
    const { t } = useTranslation();

    function handleSelect(roleId: number) {
        if (submitted) return;
        setSubmitted(true);
        onExecute(() => response.selectRole(roleId));
    }

    return (
        <Modal header={t('role.selectTitle')} testId="role-selection-modal">
            <ModalBody>
                <Stack space={8}>
                    {response.roles.map(role => (
                        <Button
                            key={role.id}
                            type="button"
                            theme="hollow"
                            size="full-width"
                            disabled={submitted}
                            loading={submitted}
                            onClick={() => handleSelect(role.id)}
                            testId={`role-selection-${role.id}`}
                        >
                            <span className="punch-pad__role-option">
                                {role.color && (
                                    <span
                                        className="punch-pad__role-color"
                                        style={{ backgroundColor: role.color }}
                                    />
                                )}
                                {role.name}
                            </span>
                        </Button>
                    ))}
                    <Button
                        type="button"
                        theme="hollow"
                        size="full-width"
                        disabled={submitted}
                        onClick={onDismiss}
                        testId="role-selection-cancel"
                    >
                        {t('common.cancel')}
                    </Button>
                </Stack>
            </ModalBody>
        </Modal>
    );
}
